import * as React from "react";
import {
    IsClientUpdateNoticeDevelopmentOverrideEnabled,
    SetClientUpdateNoticeDevelopmentOverride,
    SubscribeToClientUpdateNoticeDevelopmentOverride,
} from "source/app/services/ClientUpdate/ClientUpdateChecker";
import { IsProduction } from "source/app/services/External/Environment/Environment";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";

export function ClientUpdateNoticeDevelopmentControl() {
    const isProduction = IsProduction();
    const [isEnabled, setIsEnabled] = React.useState(
        IsClientUpdateNoticeDevelopmentOverrideEnabled
    );

    React.useEffect(
        () => SubscribeToClientUpdateNoticeDevelopmentOverride(setIsEnabled),
        []
    );

    if (isProduction) {
        return null;
    }

    return (
        <div
            className={StyleClassAuto({
                margin: "10px 0",
                fontSize: "12px",
                opacity: 0.82,
            })}
        >
            <label
                className={StyleClassAuto({
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    userSelect: "none",
                })}
            >
                <input
                    type="checkbox"
                    checked={isEnabled}
                    onChange={(event) =>
                        SetClientUpdateNoticeDevelopmentOverride(
                            event.target.checked
                        )
                    }
                />
                Show client update notice
            </label>
            <div className={StyleClassAuto({ marginTop: "6px", opacity: 0.72 })}>
                Development-only test switch
            </div>
        </div>
    );
}
